export default __webpack_public_path__ + "static/media/hazard_map.dc315ad7.jpg";